import React from 'react';

import { BodyText } from '../codeForm/CodeForm-styled-components';
import { CheckoutLinkButton } from '../common/input-styled-components';

import { ResendCodeText, ResendCodeWrapper } from './ResendCode-styled-components';

interface ResendCodeProps {
  resendOtpToUser: () => void;
  resendCooldown: number;
  isLoading: boolean;
}

export const ResendCode = ({
  resendOtpToUser,
  resendCooldown,
  isLoading,
}: ResendCodeProps) => {
  return (
    <ResendCodeWrapper>
      <ResendCodeText>
        <span>Didn't receive anything?{' '}</span>
        <CheckoutLinkButton
          onClick={resendOtpToUser}
          disabled={isLoading || resendCooldown > 0}
        >
          Resend Code
          {resendCooldown > 0 && ` (${resendCooldown}s)`}
        </CheckoutLinkButton>
      </ResendCodeText>

      <BodyText>Remember to check your spam folder</BodyText>
    </ResendCodeWrapper>
  );
};
